<!--
  * name: Pagination
  * description: 페이징 컴포넌트
-->
<template>
  <div class="paging-style mt-4">
    <a href="" class="paging-style-a" :disabled="currentRange == 1" @click.prevent="moveToPage(1)">
      <img src="@/assets/images/common/arrow_leftDouble_gray.svg" class="paging-style-img" alt="이전 페이지" />
    </a>
    <a href="" class="paging-style-a" @click.prevent="moveToPage(value - 1)">
      <img src="@/assets/images/common/arrow_left_gray.svg" class="paging-style-img" alt="이전 페이지" />
    </a>
    <a href="" class="paging-style-a" v-for="page in rangeList"
      :key="page" :class="{ active: isActivePage(page) }" :disabled="isActivePage(page)" @click.prevent="moveToPage(page)">
      {{ page }}
    </a>
    <a href="" class="paging-style-a" @click.prevent="moveToPage(value + 1)">
      <img src="@/assets/images/common/arrow_right_gray.svg" class="paging-style-img" alt="다음 페이지"/>
    </a>
    <a href="" class="paging-style-a" @click.prevent="moveToPage(lastPage)">
      <img src="@/assets/images/common/arrow_rightDouble_gray.svg" class="paging-style-img" alt="이전 페이지"/>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    value: { // 현재 페이지
      type: Number,
      required: true,
    },
    pageSize: { // 한 페이지당 보여질 데이터 수
      type: Number,
      required: true,
    },
    rangeSize: { // 한페이지 블록 당 보여질 페이지 수
      type: Number,
      required: true,
    },
    totalCount: { // 데이터 총 갯수
      type: Number,
      required: true,
    },
  },
  computed: {
    lastPage() { // 마지막 페이지
      const lastPage = Math.ceil(this.totalCount / this.pageSize);
      return lastPage === 0 ? 1 : lastPage;
    },
    endPage() { // 한 블록에 보여질 마지막 페이지
      const page = Math.ceil(this.value / this.rangeSize) * this.rangeSize;
      if (page > this.lastPage) {
        return this.lastPage;
      }
      return page;
    },
    startPage() { // 한 블록에 보여질 첫 페이지
      const page = (this.currentRange - 1) * this.rangeSize + 1;
      if (page < 1) {
        return 1;
      }
      return page;
    },
    rangeList() { // 한 블록에 보여질 페이지 리스트
      return this._.range(this.startPage, this.endPage + 1);
    },
    currentRange() { // 현재 블록 범위
      return Math.floor((this.value - 1) / this.rangeSize) + 1;
    },
  },
  methods: {
    // ## 활성화된 페이지 여부 체크 메소드
    isActivePage(page) {
      return this.value === page;
    },
    // ## 페이지 이동 처리 메소드
    moveToPage(page) {
      let currentPage = page;
      if (currentPage < 1) {
        currentPage = 1;
      } else if (currentPage > this.lastPage) {
        currentPage = this.lastPage;
      }
      this.$emit('input', currentPage);
    },
  },
};
</script>
